// Auto-generated by scripts/write-version.js — do not edit manually.
export const APP_VERSION = "1.0.0"
export const APP_BUILD = "851b59b"
